import { createContext, useContext, useEffect, useState } from "react";

const ConnectivityStatusContext = createContext(true);

export function ConnectivityStatusProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [online, setOnline] = useState(() => navigator.onLine);
  useEffect(() => {
    const update = () => setOnline(navigator.onLine);
    window.addEventListener("offline", update);
    window.addEventListener("online", update);
    update();
    return () => {
      window.removeEventListener("offline", update);
      window.removeEventListener("online", update);
    };
  }, []);
  return (
    <ConnectivityStatusContext.Provider value={online}>
      {children}
    </ConnectivityStatusContext.Provider>
  );
}

export const useConnectivityStatus = () =>
  useContext(ConnectivityStatusContext);
